import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';

export const AlertDialogPortal = AlertDialogPrimitive.Portal;
